import React from 'react';
import { Link } from 'react-router-dom';
import { getProductTypeIcon } from '../../utils/productTypeIcons';
import { categoryBackgrounds, normalizeTypeName } from './homePage.data';
import HomeSectionHeader from './HomeSectionHeader';
import { HomeTypeSectionProps } from '../interfaces';

import './HomeTypeSection.scss';


const HomeTypeSection: React.FC<HomeTypeSectionProps> = ({ productTypes }) => (
  <section className="home-section" aria-labelledby="shop-by-type-title">
    <HomeSectionHeader
      eyebrow="Shop by type"
      title="Choose a product category"
      titleId="shop-by-type-title"
      linkLabel="Start with rings"
      linkTo="/products/types/Rings"
    />
    <div className="home-type-grid">
      {productTypes.map((type) => {
        const imageUrl = getProductTypeIcon(type.name, type.image?.publicUrl);
        const backgroundUrl = categoryBackgrounds[normalizeTypeName(type.name)];

        return (
          <Link
            key={type.name}
            to={`/products/types/${type.name}`}
            className={`home-type-tile${backgroundUrl ? ' home-type-tile--background' : ''}`}
            style={
              backgroundUrl
                ? ({ '--home-type-background': `url(${backgroundUrl})` } as React.CSSProperties)
                : undefined
            }
          >
            <span className="home-type-tile__media">
              {imageUrl ? (
                <img src={imageUrl} alt={type.name} />
              ) : (
                <span>{type.name.charAt(0).toUpperCase()}</span>
              )}
            </span>
            <span className="home-type-tile__title">{type.name}</span>
          </Link>
        );
      })}
    </div>
  </section>
);

export default HomeTypeSection;
